import { alpha, Drawer, styled } from '@mui/material';

import { DrawerAction } from '@/components/Layout';

export const StyledDrawer = styled(Drawer)(({ theme }) => ({
  ':not(MuiPopover-root):not(.MuiMenu-root)': {
    '.MuiModal-backdrop': {
      backgroundColor: alpha(theme.palette.neutral[1000] as string, 0.5),
    },
  },
}));

export const GDPRDrawerAction = styled(DrawerAction)(({ theme }) => ({
  padding: theme.spacing(2),
  [theme.breakpoints.up('lg')]: {
    maxWidth: 360,
    paddingBottom: theme.spacing(4),
  },
}));
